import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/fin-ui';

import { WalletCard } from '@kr/models';

import { TransferComponent } from './transfer.component';

@Injectable()
export class TransferDialog {
  readonly #dialog = inject(DialogService);

  open(wallet: WalletCard, wallets: WalletCard[]): DialogRef {
    return this.#dialog.open(TransferComponent, { wallet, wallets });
  }
}
